import {
  API_BASE_URL,
  makePostAxiosCallWithCookies,
} from "@/libs/apis/commons";

const postRequest3DDownload = () => `${API_BASE_URL}/users/token/download`;

/**
 * 3D file download POST request
 * @see https://musical-adventure-jm7wgn3.pages.github.io/3-references/apis/#post-/users/token/download
 */
export const makeApiRequest3DDownload = async (
  collectionSlug: string,
  tokenId: string,
  legalURL: string,
) => {
  return await makePostAxiosCallWithCookies(postRequest3DDownload(), {
    legalURL,
    tokenId,
    collectionSlug,
  });
};
